import React from 'react'
import { connect } from 'react-redux'
import { actionCreators } from '@/store/ReportGroupCycleParameters'
import { EditCycleParametersDialog } from './dialog'
import { LoadingDialog } from '@/dialogs/common/loadingDialog'

class EditCycleParametersDialogShell extends React.Component {
  componentDidMount () {
    const { reportGroupId, reportingCycleSubmissionId } = this.props
    this.props.get({ reportGroupId, reportingCycleSubmissionId })
  }
  onSave (data) {
    const { reportGroupId, reportingCycleSubmissionId } = this.props
    const dto = { reportGroupId, reportingCycleSubmissionId, data }
    this.props.save(dto, () => this.props.onAction())
  }
  render () {
    if (this.props.loading) { return <LoadingDialog {...this.props} /> }

    const { reportGroupCycleParameter, componentKey, get, save, data, ...otherProps } = this.props
    return (
      <EditCycleParametersDialog
        key={componentKey}
        {...data}
        {...otherProps}
        onAction={data => this.onSave(data)}
      />
    )
  }
}

function mapStateToProps (state) {
  return {
    ...state.reportGroupCycleParameter
  }
}

const mapDispatchToProps = {
  get: actionCreators.get,
  save: actionCreators.save
}

export default {
  component: connect(mapStateToProps, mapDispatchToProps)(EditCycleParametersDialogShell),
  modalProps: { size: 'lg' }
}



// WEBPACK FOOTER //
// ./src/dialogs/editCycleParameters/index.js